/* 閲覧履歴 */
import {
  getCookieValue,
  CustomIntersectionObserver,
  EasySlider,
  getProductCardsArray,
  createProductCardHtml
} from "./my-utilities.min.js?v=202504021529";
export {
  setRecentlyViewed
};
// HTMLレンダリング
class RecentlyProducts extends HTMLElement {
  constructor() {
    super();
    // 履歴データ
    this.recentlyData = '';
    this.init();
  }

  connectedCallback() {
    // 処理ターゲット
    this.renderTarget = this.querySelector('ul');
  }

  init() {
    // 対象Cookieを取得
    const recentlyItems = getCookieValue('wl-recently-viewd-item');
    
    if (recentlyItems) {
      // 空でなければ処理継続
      this.recentlyData = recentlyItems;

      // 要素の監視開始
      this.setInterObserve();
    }
  }

  setInterObserve() {
    const observer = new CustomIntersectionObserver({
      target: this,
      // 要素がビューポートに入ると、HTMLが生成される
      onEnter: () => this.parseRecentlyHTML()
    });
  }

  // Cookieから取得した商品IDとバリアントIDを商品情報生成モジュールに渡し、返ってきたHTML要素の配列をレンダリング
  async parseRecentlyHTML() {
    const ids = this.recentlyData.split(',');
    // sectionの設定を参照する
    const maxCount = this.dataset.max;
    const parsedIds = ids.slice(0, maxCount); // 不要な処理を避けるため、配列を最大maxCountに絞り込む

    // 解析用の配列作成 商品HTML作成のためのオブジェクトが格納される
    const getProductCardPromises = parsedIds.map(async (id) => {
      // 11-2222-333:0123456789 形式を処理用に分割
      const idParts = id.split(':');
      const productHandle = idParts[0];
      const variantId = Number(idParts[1]);
      // モジュールファイルの、商品情報オブジェクト作成関数
      const result = await getProductCardsArray(productHandle, variantId);
      return result;
    });

    try {
      // 完了を待ってからHTMLレンダリング
      const results = await Promise.all(getProductCardPromises);

      const filteredResults = results.filter(item => item !== null); // 空白要素を削除

      // 配列をもとにHTML生成
      if (filteredResults.length > 0){
        // 配列をHTML要素に整形した、新たな配列
        const parsedProductCards = filteredResults.map(item => createProductCardHtml(item, true));
        
        // レンダリング対象要素を空に
        this.renderTarget.innerHTML = '';
        // parsedProductCards.forEach(html => this.renderTarget.insertAdjacentHTML('beforeend', html)); // 順に出力（下記の方が処理速度に優れる）
        this.renderTarget.innerHTML = parsedProductCards.join(''); // 配列内全要素を連結してターゲットに追記

        // さらにターゲットのulをスライダー化
        const recentlyProducts = new EasySlider({
          target: this.renderTarget,
          margin: 3,
          itemsPerViewSp: this.dataset.perViewSp,
          itemsPerViewPc: this.dataset.perViewPc
        });
      }
    } catch (error) {
      console.error("[parseRecentlyHTML] An error occurred while parsing HTML:", error);
    }
  };

}
customElements.define('recently-products', RecentlyProducts);

/**
  * 最大12件までの履歴をCookieに保存する関数
  * 特定商品の時は関数を走らせない
  *  - 価格が0円、商品タイプが「ギフトラッピング商品」「メッセージカード商品」「ノベルティ商品」
  * @param {string} productHandle - 商品ハンドル 社内ID
  * @param {string} variantId - バリアント Shopify管理ID
  */
function setRecentlyViewed(productHandle, variantId) {
  // 商品情報の取得
  const product_handle = productHandle;
  const variant_id = variantId;
  
  // 内容を加工するため、Cookieから値を取得
  const recentArray = getCookieValue('wl-recently-viewd-item');
  const recentArraySplit = recentArray ? recentArray.split(',') : [];
  
  // 新しい履歴を先頭に追加
  const valueToAdd = product_handle + ':' + variant_id;
  recentArraySplit.unshift(valueToAdd);
  
  // 重複を削除し、最大12件まで制限
  const filteredArray = recentArraySplit.filter((ele, pos) => recentArraySplit.indexOf(ele) === pos);
  const limitedArray = filteredArray.slice(0, 12);
  
  // 有効期限を設定してCookieに保存
  // const expirationDate = dayjs().add(30, 'd').format('YYYY/MM/DD');
  // document.cookie = 'wl-recently-viewd-item=' + limitedArray.join(',') + '; Path=/; expires=' + expirationDate;
  document.cookie = 'wl-recently-viewd-item=' + limitedArray.join(',') + '; path=/';

}